import { render, staticRenderFns } from "./ProfilePassport.vue?vue&type=template&id=2695e091"
import script from "./ProfilePassport.js?vue&type=script&lang=js&external"
export * from "./ProfilePassport.js?vue&type=script&lang=js&external"
import style0 from "./ProfilePassport.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports